export enum WireComponentKind {
    // shared
    TextField = "text-field",
    NumberField = "number-field",
    EmailField = "email-field",
    PhoneField = "phone-field",
    DateTimeField = "date-field",
    FilePicker = "file-picker",
    ImagePicker = "image-picker",
    Toggle = "toggle",
    ActivitySpinner = "activity-spinner",

    // pages
    Button = "page-button",
    Hint = "page-hint",
    Hero = "hero",
    ContactForm = "contact-form",
    DynamicButtonBar = "dynamic-button-bar",
    ButtonsBlock = "buttons-block",
    List = "list",
    Container = "container",
    InternalSeparator = "internal-separator",
    FormContainer = "form-container",
    TabsNavigationBarContainer = "tabs-navigation-bar-container",
    Fields = "fields",
    BigNumbers = "big-numbers",
    Breadcrumbs = "breadcrumbs",
    RichText = "page-rich-text",
    Note = "page-note",
    Image = "page-image",
    SimpleImage = "page-simple-image",
    Video = "page-video",
    SimpleVideo = "page-simple-video",
    Separator = "page-separator",
    SignIn = "sign-in",
    Custom = "custom",
    Text = "text",
    WebView = "page-web-view",
    AICustomComponent = "ai-custom-component",
    AICustomChatComponent = "ai-custom-chat-component",
    Discovery = "data-discovery",
    InlineScanner = "inline-scanner",
    Location = "page-location",
    Link = "page-link",
    // SignaturePad is the component we show in the sign overlay
    SignaturePad = "page-signature-pad",
    // SignatureField is the component that you can slap in your Page
    // it trigger the sign overlay
    SignatureField = "page-signature-field",
    ActionRow = "page-action-row",
    PageRating = "page-rating",
    PageProgress = "page-progress",
    PageAudio = "page-audio",
    PageAudioRecorder = "page-audio-recorder",
    MultipleFilters = "page-multiple-filters",
    RenderableContent = "page-renderable-content",
    Stopwatch = "page-stopwatch",
    Spinner = "page-spinner",
    VoiceEntry = "page-voice-entry",
    TabsNavigationBar = "page-tabs-navigation-bar",
    AppCodeScannerScreen = "app-code-scanner-screen", // still used in Pages
}
